export const PRODUCTCARD_CANONICAL_TYPENAMES = {
  COURSE: 'COURSE',
  SPECIALIZATION: 'SPECIALIZATION',
  DEGREE: 'DEGREE',
  CLIP: 'CLIP',
};
export const PRODUCT_CARD_V2_IMAGE_DEFAULT_VALUES = { height: 180, width: 320, fit: 'crop' };

export const MIN_RATING_COUNT = 5;
